import React from 'react';
import { useSelectEvent } from '@stitch-fix/event-reporter';
import ModuleHeader, { ModuleHeaderProps } from '../ModuleHeader';

type CategorySetModuleHeaderProps = {
  categorySetId: string;
  moduleHeader: ModuleHeaderProps;
};

/**
 * Instruments a <ModuleHeader> with a category_set_select event on clicking the CTA
 */
const CategorySetModuleHeader = ({
  categorySetId,
  moduleHeader,
}: CategorySetModuleHeaderProps) => {
  const { reportSelectEvent } = useSelectEvent();

  const { cta } = moduleHeader;

  const ctaWithOnClick = cta
    ? {
        ...cta,
        onClick: () => {
          reportSelectEvent({
            schema: 'category_set_select',
            action_name: 'navigate_to_category_set',
            name: 'view_all_link',
            category_set_id: categorySetId,
          });

          cta.onClick?.();
        },
      }
    : undefined;

  return <ModuleHeader {...moduleHeader} cta={ctaWithOnClick} />;
};

export default CategorySetModuleHeader;
